import { useEffect, useRef, useState } from "react";
import { Dropdown } from "flowbite-react";
import _ from "lodash";
import LoaderCircle from "../LoaderCircle";
import { currentSurahNum,isMediaPlayerPlaying } from "../../../stores/sessionStore";
import SpeedControls from "./SpeedControls";

const recitersList=[
    {
      "value": "Abdul_Basit_Mujawwad_128kbps",
      "label": "AbdulBasit (Mujawwad)",
      "reciter_name": "abdulbasit-mujawwad"
    },
    {
      "value": "Abdul_Basit_Murattal_192kbps",
      "label": "AbdulBasit (Murattal)",
      "reciter_name": "abdulbasit-murattal"
    },
    {
      "value": "Abdullah_Basfar_192kbps",
      "label": "Abdullah Basfar",
      "reciter_name": "abdullah-basfar"
    },
    {
      "value": "Abdurrahmaan_As-Sudais_192kbps",
      "label": "Abdurrahmaan As-Sudais",
      "reciter_name": "abdurrahmaan-as-sudais"
    },
    {
      "value": "Hudhaify_128kbps",
      "label": "Al-Hudhaify",
      "reciter_name": "al-hudhaify"
    },
    {
      "value": "Husary_128kbps_Mujawwad",
      "label": "Al-Husary (Mujawwad)",
      "reciter_name": "al-husary-mujawwad"
    },
    {
      "value": "Minshawy_Mujawwad_192kbps",
      "label": "Al-Minshawy (Mujawwad)",
      "reciter_name": "al-minshawy-mujawwad"
    },
    {
      "value": "Minshawy_Murattal_128kbps",
      "label": "Al-Minshawy (Murattal)",
      "reciter_name": "al-minshawy-murattal"
    },
    {
      "value": "Abu_Bakr_Ash-Shaatree_128kbps",
      "label": "Ash-Shaatree",
      "reciter_name": "ash-shaatree"
    },
    {
      "value": "Saood_ash-Shuraym_128kbps",
      "label": "Ash-Shuraym",
      "reciter_name": "ash-shuraym"
    },
    {
      "value": "Hani_Rifai_192kbps",
      "label": "Hani Rifai",
      "reciter_name": "hani-rifai"
    },
    {
      "value": "Alafasy_128kbps",
      "label": "Mishary Rashid Al-Afasy",
      "reciter_name": "mishary-rashid-al-afasy"
    },
    {
      "value": "Muhammad_Jibreel_128kbps",
      "label": "Muhammad Jibreel (128 kbps)",
      "reciter_name": "muhammad-jibreel-128-kbps"
    },
    {
      "value": "Muhammad_Jibreel_64kbps",
      "label": "Muhammad Jibreel (64 kbps)",
      "reciter_name": "muhammad-jibreel-64-kbps"
    },
    {
      "value": "ahmed_ibn_ali_al_ajamy_128kbps",
      "label": "Ahmed Ibn Ali Al-Ajamy",
      "reciter_name": "ahmed-ibn-ali-al-ajamy"
    },
    {
      "value": "Ali_Jaber_64kbps",
      "label": "Ali Jaber",
      "reciter_name": "ali-jaber"
    },
    {
      "value": "Muhsin_Al_Qasim_192kbps",
      "label": "Muhsin Al Qasim",
      "reciter_name": "muhsin-al-qasim"
    },
    {
      "value": "Nasser_Alqatami_128kbps",
      "label": "Nasser Alqatami",
      "reciter_name": "nasser-alqatami"
    },
    {
      "value": "Fares_Abbad_64kbps",
      "label": "Fares Abbad",
      "reciter_name": "fares-abbad"
    },
    {
      "value": "Abdullaah_3awwaad_Al-Juhaynee_128kbps",
      "label": "Abdullaah Awwaad Al-Juhaynee",
      "reciter_name": "abdullaah-awwaad-al-juhaynee"
    }
];

const MediaPlayer=({nowPlaying, closeFunc, reciter, reciterCode})=>{
    //Basic functionality states
    const [playList,setPlayList]=useState(null);
    const [currentTrack, setCurrentTrack] = useState(0);
    const [isPlaying,setIsPlaying]=useState(false);
    const [isLoading,setIsLoading]=useState(false);
    const [isMuted,setIsMuted]=useState(false);
    const [volume, setVolume] = useState(0.5);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [selectedSpeed, setSelectedSpeed] = useState('1');
    const [selectedReciter,setSelectedReciter]=useState(recitersList.find(
        (reciter) => reciter.value === reciterCode
    ));

    // repeat functinality states
    const [isRepeatMenuOpen, setIsRepeatMenuOpen] = useState(false);
    const [isRangeRepeatChecked, setIsRangeRepeatChecked] = useState(true);
    const [isSurahRepeatChecked, setIsSurahRepeatChecked] = useState(false);
    const [showRangeControls, setShowRangeControls] = useState(true);
    const [repeatAmtRange, setRepeatAmtRange] = useState(1);
    const [repeatAmt, setRepeatAmt] = useState(1);
    const [fromRange, setFromRange] = useState(1);
    const [toRange, setToRange] = useState(nowPlaying.count);

    const audioRef = useRef(null);
    const volSliderRef = useRef(null);
    const timelineRef = useRef(null);
    const progressRef = useRef(null);

    const speedOptions = [
        { value: '0.25', label: '0.25x' },
        { value: '0.5', label: '0.5x' },
        { value: '1', label: '1x' },
        { value: '1.5', label: '1.5x' },
        { value: '2', label: '2x' },
    ];  

    const generatePlaylist = () => {
        const surahNum = nowPlaying.id;
        const ayahCount = nowPlaying.count;
        const baseUrl = `https://alim-quran.s3.amazonaws.com/recitation/${selectedReciter.value}/`;   
        const surahStr = surahNum.toString().padStart(3, '0'); // Format surah number to 3 digits
        
        // Initialize playlist array
        const playlistArr = [];
        
        // Add '001001.mp3' to the beginning for surahs except 1 and 9
        if (surahNum !== 1 && surahNum !== 9) {
            playlistArr.push({
                ayahId: 'Bismi',  // No padding zeros for this ayah id
                url: `${baseUrl}001001.mp3`
            });
        }
        
        // Check the repeatAmtRange (assuming it's a number or an array of ranges for each ayah)
        const ayahRepeatCount = Number(repeatAmtRange);
        
        // Ensure the fromRange and toRange are within the valid limits of the surah's ayah count
        const fromAyah = Math.max(1, fromRange); // Ensure it doesn't go below 1
        const toAyah = Math.min(ayahCount, toRange); // Ensure it doesn't exceed the total ayah count
        
        // Loop through the specified range of ayahs (fromRange to toRange)
        for (let i = fromAyah - 1; i < toAyah; i++) { // Adjust index since fromRange is 1-based
            const ayahId = (i + 1).toString(); // Ayah ID without padded zeros
            const ayahAudioFile = `${baseUrl}${surahStr}${ayahId.padStart(3, '0')}.mp3`;  // Add padded zeros for the URL
            
            // Repeat the current ayah audio based on repeatAmtRange and push all at once as an object
            for (let j = 0; j < ayahRepeatCount; j++) {
                playlistArr.push({
                    ayahId: ayahId,  // No padded zeros for the id
                    url: ayahAudioFile
                });
            }
        }
        
        setIsPlaying(true);
        setPlayList(playlistArr);
    };

    const playAudio = () => {
        if (audioRef.current) {
            audioRef.current.play();
            setIsPlaying(true);
        }
    };
    
    const pauseAudio = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const gotoPrev=()=>{
        if (currentTrack > 0) {
            setCurrentTrack((prev) => prev - 1);
        }
    }

    const gotoNext=()=>{
        if (currentTrack < playList.length - 1) {
            setCurrentTrack((prev) => prev + 1);
        }
    }

    const skipBackward=()=>{
        if (audioRef.current) {
            audioRef.current.currentTime = Math.max(0, audioRef.current.currentTime - 2); // Skip 2 seconds backward, but not below 0
        }
    }

    const skipForward=()=>{
        if (audioRef.current) {
            audioRef.current.currentTime += 2; // Skip 2 seconds forward
        }
    }

    const handleEnded = () => {
        if (currentTrack < playList.length - 1) {
            setCurrentTrack((prev) => prev + 1);
        } else {
            if(repeatAmt>1)
            {
                setRepeatAmt(prev=>prev-1);
                setCurrentTrack(0);
            }
            else
            {
                setIsPlaying(false); // Stop playback
                setCurrentTrack(0); // Reset to the beginning of the playlist
            }
        }
    };

    const handleWaiting=()=>{
        setIsLoading(true);
        setIsPlaying(false);
    }

    const handlePlaying=()=>{
        setIsLoading(false);
        setIsPlaying(true);
    }

    const handleVolume = (e) => {
        const sliderWidth = volSliderRef.current.offsetWidth; // Get slider width
        const newVolume = e.nativeEvent.offsetX / sliderWidth; // Calculate volume
        setVolume(newVolume); // Update state
    };

    const muteVolume=()=>{
        if(audioRef.current)
        {
            audioRef.current.muted=true;
            setIsMuted(true);
        }
    }

    const unMuteVolume=()=>{
        if(audioRef.current)
        {
            audioRef.current.muted=false;
            setIsMuted(false);
        }
    }

    const handleTimelineClick = (e) => {
        if (timelineRef.current && audioRef.current) {
          const timelineWidth = timelineRef.current.offsetWidth;
          const clickPosition = e.nativeEvent.offsetX;
          const newTime = (clickPosition / timelineWidth) * audioRef.current.duration;
          audioRef.current.currentTime = newTime;
          setCurrentTime(newTime);
        }
    };

    const getTimeCodeFromNum = (num) => {
        const minutes = Math.floor(num / 60);
        const seconds = Math.floor(num % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    const handleLoadedMetadata = () => {
        if (audioRef.current) {
            setDuration(audioRef.current.duration);
        }
    };

    const handleSpeedChange = (event) => {
        const newSpeed = event.target.value;
        setSelectedSpeed(newSpeed);
    
        // Update the playback rate of the audio element
        if (audioRef.current) {
            audioRef.current.playbackRate = parseFloat(newSpeed);
        }
    };

    //Repeat functionality codes
    const handleRangeRepeatChange = () => {
        setIsRangeRepeatChecked(true);
        setIsSurahRepeatChecked(false);
        setShowRangeControls(true);
    };

    const handleSurahRepeatChange = () => {
        setFromRange(1);
        setToRange(nowPlaying.count)
        setIsSurahRepeatChecked(true);
        setIsRangeRepeatChecked(false);
        setShowRangeControls(false);
    };

    const handleFromRangeChange = (e) => {
        setFromRange(Number(e.target.value));
    };

    const handleToRangeChange = (e) => {
        setToRange(Number(e.target.value));
    };

    const handleRepeatAmtRangeChange = (e) => {
        setRepeatAmtRange(e.target.value);
    };

    const handleRepeatAmtChange = (e) => {
        setRepeatAmt(Number(e.target.value));
    };

    const handleStartPlaying = () => {
        // Handle start playing functionality here
        setCurrentTrack(0);
        generatePlaylist();
    };

    const handleReciterChange=(e)=>{
        const newReciter = JSON.parse(event.target.value);
        setSelectedReciter(newReciter);
    }

    useEffect(() => {
        if(!isRepeatMenuOpen)
        {
            setIsRepeatMenuOpen(true);
        }
    }, [isRepeatMenuOpen]);

    useEffect(() => {
        generatePlaylist();
    }, [selectedReciter]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = volume;
        }
    }, [volume]);

    useEffect(()=>{
        if (audioRef.current&&playList!==null) {
            try {
                audioRef.current.pause();
                audioRef.current.src = playList[currentTrack].url;
            } catch (error) {
                console.error("Error occurred while changing the audio source:", error);
            }
            audioRef.current.playbackRate=selectedSpeed;
            if (isPlaying) {
                audioRef.current.play();
            } else {
                audioRef.current.pause(); // Ensure playback doesn't resume automatically
            }
        }
    },[playList,currentTrack]);

    useEffect(()=>{
        if(!isRepeatMenuOpen)
        {
            generatePlaylist();
        }
    },[repeatAmtRange]);

    useEffect(()=>{
        isMediaPlayerPlaying.set(isPlaying);
    },[isPlaying])

    useEffect(() => {
        generatePlaylist();
        const audio = audioRef.current;
        const updateProgress = () => {
            if (audio) {
                setCurrentTime(audio.currentTime);
                if (progressRef.current) {
                    progressRef.current.style.width = `${(audio.currentTime / audio.duration) * 100}%`;
                }
            }
        };

        currentSurahNum.set(nowPlaying.id);
    
        // Update progress at intervals
        const interval = setInterval(updateProgress, 500);
    
        return () => clearInterval(interval); // Cleanup interval on component unmount
    }, []);

    return(
        <div className="audio-player-new backdrop-blur-md min-h-[60px] fixed bottom-0 left-0 w-full z-[48]">
            <>
                {/* <div
                    ref={timelineRef}
                    onClick={handleTimelineClick}
                    className="w-full h-0.5 bg-white cursor-pointer timeline"
                >
                    <div ref={progressRef} className="progress bg-deep-red"></div>
                </div>
                <div className="flex justify-between gap-0 lg:gap-4 px-5 pt-3 pb-2 controls">
                    <div className="lg:col-span-2 time hidden lg:block">
                        <div className="bg-white/10 w-20 text-center rounded p-2"><span className="text-white/50 current">{getTimeCodeFromNum(currentTime)}</span></div>
                    </div>
                    <div className="flex max-w-screen-xl gap-3 w-full lg:w-fit">
                    <div className="lg:col-span-2 min-w-[260px] hidden lg:flex">
                        <div className="volume-container">
                            <div className="p-1 pt-3 volume-button">
                                {
                                    isMuted?
                                        <img id="media-mute-btn" src="/images/media-player/mute.svg" width="20" height="17" alt="Unmute button" onClick={unMuteVolume}/>
                                    :
                                        <img id="media-volume-btn" src="/images/media-player/audio.svg" width="20" height="17" alt="Mute button" onClick={muteVolume}/>
                                }
                            </div>
                            <div 
                                className="volume-slider" 
                                ref={volSliderRef}
                                onClick={handleVolume}
                            >
                                <div 
                                    className="volume-percentage"
                                    style={{
                                        width: `${volume * 100}%`,
                                    }}
                                ></div>
                            </div>
                        </div>
                        <div id="media-info" className="text-white/50 p-2">
                            {
                                playList!==null?
                                    `${nowPlaying.name} (${nowPlaying.id}:${playList[currentTrack].ayahId})`
                                :
                                    null
                            }
                        </div>
                        <button className="p-2" onClick={()=>{closeFunc(false)}}> 
                                <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.29279 8.30529C7.48031 8.11782 7.73462 8.0125 7.99979 8.0125C8.26495 8.0125 8.51926 8.11782 8.70679 8.30529L12.9998 12.5983L17.2928 8.30529C17.385 8.20978 17.4954 8.1336 17.6174 8.08119C17.7394 8.02878 17.8706 8.00119 18.0034 8.00004C18.1362 7.99888 18.2678 8.02419 18.3907 8.07447C18.5136 8.12475 18.6253 8.199 18.7192 8.29289C18.8131 8.38679 18.8873 8.49844 18.9376 8.62133C18.9879 8.74423 19.0132 8.87591 19.012 9.00869C19.0109 9.14147 18.9833 9.27269 18.9309 9.39469C18.8785 9.5167 18.8023 9.62704 18.7068 9.71929L14.4138 14.0123L18.7068 18.3053C18.8889 18.4939 18.9897 18.7465 18.9875 19.0087C18.9852 19.2709 18.88 19.5217 18.6946 19.7071C18.5092 19.8925 18.2584 19.9977 17.9962 20C17.734 20.0022 17.4814 19.9014 17.2928 19.7193L12.9998 15.4263L8.70679 19.7193C8.51818 19.9014 8.26558 20.0022 8.00339 20C7.74119 19.9977 7.49038 19.8925 7.30497 19.7071C7.11956 19.5217 7.01439 19.2709 7.01211 19.0087C7.00983 18.7465 7.11063 18.4939 7.29279 18.3053L11.5858 14.0123L7.29279 9.71929C7.10532 9.53176 7 9.27745 7 9.01229C7 8.74712 7.10532 8.49282 7.29279 8.30529Z" fill="#9CA3AF"/>
                                <circle cx="13" cy="14" r="13" fill="white" fillOpacity="0.1"/>
                            </svg> 
                        </button>
                    </div>
                    <div className="w-full">
                        <div className="bg-white/10 text-center rounded px-2 py-1 flex w-full justify-between lg:justify-normal lg:w-56 h-10 mx-auto items-center">
                            <div className="w-20 flex text-center rounded px-2 py-1 lg:hidden">
                                <span className="text-white/50 current min-w-[35px]" id="timer-mobile">{getTimeCodeFromNum(currentTime)}</span>
                            </div>
                    
                            <button onClick={skipBackward} className="text-white/50 px-2 flex items-center hidden lg:block">
                                <svg width="25" height="23" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.66699 18.5625C4.66699 21.01 5.41477 23.4026 6.81575 25.4377C8.21674 27.4727 10.208 29.0589 12.5378 29.9955C14.8675 30.9321 17.4311 31.1772 19.9044 30.6997C22.3777 30.2222 24.6495 29.0436 26.4326 27.3129C28.2157 25.5823 29.43 23.3773 29.922 20.9767C30.414 18.5762 30.1615 16.088 29.1965 13.8268C28.2314 11.5656 26.5972 9.63285 24.5005 8.27306C22.4038 6.91328 19.9387 6.1875 17.417 6.1875H13.167V1.03125L6.79199 7.21875L13.167 13.4063V8.25H17.417C19.5184 8.25 21.5727 8.85482 23.3199 9.98797C25.0672 11.1211 26.429 12.7317 27.2332 14.6161C28.0374 16.5004 28.2478 18.5739 27.8378 20.5744C27.4279 22.5748 26.4159 24.4123 24.93 25.8545C23.4441 27.2968 21.5509 28.2789 19.4898 28.6769C17.4288 29.0748 15.2924 28.8705 13.351 28.09C11.4095 27.3095 9.75012 25.9877 8.58263 24.2918C7.41514 22.5959 6.79199 20.6021 6.79199 18.5625H4.66699Z" fill="white" fillOpacity="0.5"/>
                                    <path d="M21.2735 22.8223C20.804 22.8335 20.3383 22.7382 19.9135 22.5439C19.5363 22.3581 19.2116 22.0854 18.9679 21.7498C18.7007 21.3583 18.5132 20.9207 18.4154 20.4608C18.2898 19.8915 18.2293 19.3105 18.2348 18.7283C18.2305 18.1461 18.291 17.5653 18.4154 16.9958C18.5151 16.5364 18.7025 16.0992 18.9679 15.7067C19.2116 15.3711 19.5363 15.0985 19.9135 14.9126C20.3383 14.7184 20.804 14.623 21.2735 14.6342C21.7149 14.6016 22.1576 14.6793 22.5594 14.8598C22.9611 15.0403 23.3085 15.3177 23.5685 15.6655C24.1164 16.58 24.375 17.6308 24.3123 18.687C24.375 19.7432 24.1164 20.794 23.5685 21.7086C23.3184 22.0715 22.9753 22.3651 22.5729 22.5604C22.1705 22.7556 21.7227 22.8459 21.2735 22.8223ZM21.2735 21.5642C21.4877 21.5766 21.7012 21.53 21.8892 21.4296C22.0772 21.3292 22.2321 21.1792 22.336 20.997C22.5899 20.5147 22.7245 19.9815 22.7291 19.4398V18.0167C22.7521 17.4848 22.6466 16.9551 22.421 16.4698C22.3022 16.2932 22.14 16.1481 21.9489 16.0477C21.7578 15.9473 21.5439 15.8947 21.3266 15.8947C21.1093 15.8947 20.8955 15.9473 20.7044 16.0477C20.5133 16.1481 20.351 16.2932 20.2323 16.4698C20.0067 16.9551 19.9012 17.4848 19.9241 18.0167V19.4398C19.9022 19.975 20.0077 20.5078 20.2323 20.997C20.3336 21.1768 20.485 21.3253 20.6691 21.4256C20.8532 21.5259 21.0626 21.5739 21.2735 21.5642ZM11.711 22.6883V21.4714H13.836V16.1192L11.8598 17.1505L11.2754 16.0573L13.7404 14.7167H15.2916V21.4198H17.1829V22.6883H11.711Z" fill="white" fillOpacity="0.5"/>
                                </svg> 
                            </button>
                            <button onClick={gotoPrev} className="text-white/50 px-2 flex items-center">
                                <svg width="29" height="19" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M33.5584 2.39211C33.0834 2.39211 32.5847 2.53711 32.1572 2.80294L24.9609 7.44294C24.6967 7.6163 24.5109 7.88918 24.4441 8.20177C24.3773 8.51435 24.4351 8.84112 24.6047 9.11045C24.7751 9.37928 25.0432 9.56841 25.3504 9.63636C25.6576 9.70431 25.9788 9.64555 26.2434 9.47294L33.4397 4.83294C33.4397 4.83294 33.6059 4.78461 33.6772 4.83294C33.7484 4.88128 33.7959 4.95378 33.7959 5.05044V23.9488C33.7959 23.9488 33.7484 24.1179 33.6772 24.1663C33.642 24.1902 33.6007 24.2029 33.5584 24.2029C33.5162 24.2029 33.4748 24.1902 33.4397 24.1663L26.2434 19.5263C25.9788 19.3537 25.6576 19.2949 25.3504 19.3629C25.0432 19.4308 24.7751 19.6199 24.6047 19.8888C24.4351 20.1581 24.3773 20.4849 24.4441 20.7975C24.5109 21.11 24.6967 21.3829 24.9609 21.5563L32.1572 26.1963C32.9647 26.7038 33.9859 26.7521 34.8172 26.2688C35.6484 25.8096 36.1709 24.9154 36.1709 23.9488V5.05044C36.1709 4.08377 35.6484 3.18961 34.8172 2.73044C34.4134 2.51294 33.9859 2.39211 33.5584 2.39211Z" fill="white" fillOpacity="0.5"/>
                                    <path d="M21.697 2.46547C21.1982 2.46547 20.6995 2.61047 20.2482 2.90047L6.33074 12.2771C5.59449 12.7605 5.16699 13.6063 5.16699 14.5005C5.16699 15.3946 5.59449 16.2163 6.33074 16.7238L20.272 26.1005C21.0795 26.6321 22.1007 26.6805 22.9557 26.2213C23.8107 25.7621 24.3332 24.868 24.3332 23.8771V5.09964C24.3332 4.1088 23.8107 3.21464 22.9557 2.75547C22.5757 2.53797 22.1482 2.4413 21.7207 2.4413L21.697 2.46547ZM7.63699 14.6938C7.63699 14.6938 7.54199 14.5488 7.54199 14.5005L21.602 4.9063C21.602 4.9063 21.7682 4.85797 21.8395 4.9063C21.9107 4.95464 21.9582 5.02714 21.9582 5.1238V23.9013C21.9582 23.9013 21.9107 24.0705 21.8395 24.1188C21.8043 24.1427 21.763 24.1555 21.7207 24.1555C21.6785 24.1555 21.6371 24.1427 21.602 24.1188L7.63699 14.6938Z" fill="white" fillOpacity="0.5"/>
                                </svg>  
                            </button>
                            <div className="text-white/50 px-2 toggle-play flex items-center justify-center min-w-10">
                                {
                                    isLoading?
                                        <LoaderCircle/>
                                    :
                                        isPlaying?
                                            <img src="/images/media-player/pause.svg" width="15" height="20" alt="Pause button" className="min-w-[15px] cursor-pointer" onClick={pauseAudio}/>
                                        :
                                            <img src="/images/media-player/play.svg" width="15" height="20" alt="Play button" className="min-w-[15px] cursor-pointer" onClick={playAudio}/>
                                }
                            </div>
                            <button onClick={gotoNext} className="text-white/50 px-2 flex items-center">
                                    <svg width="29" height="19" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.19546 27.2134C5.67046 27.2134 6.16921 27.0684 6.59671 26.8025L13.793 22.1625C14.0572 21.9892 14.243 21.7163 14.3098 21.4037C14.3766 21.0911 14.3188 20.7643 14.1492 20.495C13.9788 20.2262 13.7107 20.0371 13.4035 19.9691C13.0963 19.9012 12.7751 19.9599 12.5105 20.1325L5.31421 24.7725C5.31421 24.7725 5.14796 24.8209 5.07671 24.7725C5.00546 24.7242 4.95796 24.6517 4.95796 24.555L4.95796 5.65669C4.95796 5.65669 5.00546 5.48753 5.07671 5.43919C5.11186 5.41529 5.15318 5.40254 5.19546 5.40254C5.23773 5.40254 5.27906 5.41529 5.31421 5.43919L12.5105 10.0792C12.7751 10.2518 13.0963 10.3106 13.4035 10.2426C13.7107 10.1747 13.9788 9.98553 14.1492 9.71669C14.3188 9.44737 14.3766 9.1206 14.3098 8.80801C14.243 8.49543 14.0572 8.22255 13.793 8.04919L6.59671 3.40919C5.78921 2.90169 4.76796 2.85336 3.93671 3.33669C3.10546 3.79586 2.58296 4.69003 2.58296 5.65669L2.58296 24.555C2.58296 25.5217 3.10546 26.4159 3.93671 26.875C4.34046 27.0925 4.76796 27.2134 5.19546 27.2134Z" fill="white" fillOpacity="0.5"/>
                                    <path d="M17.303 26.5345C17.8018 26.5345 18.3005 26.3895 18.7518 26.0995L32.6693 16.7229C33.4055 16.2395 33.833 15.3937 33.833 14.4995C33.833 13.6054 33.4055 12.7837 32.6693 12.2762L18.728 2.89953C17.9205 2.36786 16.8993 2.31953 16.0443 2.7787C15.1893 3.23786 14.6668 4.13203 14.6668 5.12286L14.6668 23.9004C14.6668 24.8912 15.1893 25.7854 16.0443 26.2445C16.4243 26.462 16.8518 26.5587 17.2793 26.5587L17.303 26.5345ZM31.363 14.3062C31.363 14.3062 31.458 14.4512 31.458 14.4995L17.398 24.0937C17.398 24.0937 17.2318 24.142 17.1605 24.0937C17.0893 24.0454 17.0418 23.9729 17.0418 23.8762L17.0418 5.0987C17.0418 5.0987 17.0893 4.92953 17.1605 4.8812C17.1957 4.8573 17.237 4.84454 17.2793 4.84454C17.3215 4.84454 17.3629 4.8573 17.398 4.8812L31.363 14.3062Z" fill="white" fillOpacity="0.5"/>
                                </svg>  
                            </button>
                            <button onClick={skipForward} className="text-white/50 px-2 flex items-center hidden lg:block">
                                <svg width="25" height="23" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M30.333 18.5625C30.333 21.01 29.5852 23.4026 28.1842 25.4377C26.7833 27.4727 24.792 29.0589 22.4622 29.9955C20.1325 30.9321 17.5689 31.1772 15.0956 30.6997C12.6223 30.2222 10.3505 29.0436 8.56739 27.3129C6.78428 25.5823 5.56996 23.3773 5.07799 20.9767C4.58603 18.5762 4.83852 16.088 5.80354 13.8268C6.76856 11.5656 8.40276 9.63285 10.4995 8.27306C12.5962 6.91328 15.0613 6.1875 17.583 6.1875H21.833V1.03125L28.208 7.21875L21.833 13.4063V8.25H17.583C15.4816 8.25 13.4273 8.85482 11.6801 9.98797C9.9328 11.1211 8.57096 12.7317 7.76678 14.6161C6.9626 16.5004 6.75219 18.5739 7.16216 20.5744C7.57213 22.5748 8.58406 24.4123 10.07 25.8545C11.5559 27.2968 13.4491 28.2789 15.5102 28.6769C17.5712 29.0748 19.7076 28.8705 21.649 28.09C23.5905 27.3095 25.2499 25.9877 26.4174 24.2918C27.5849 22.5959 28.208 20.6021 28.208 18.5625H30.333Z" fill="white" fillOpacity="0.5"/>
                                    <path d="M21.4395 22.8223C20.97 22.8335 20.5044 22.7382 20.0795 22.5439C19.7023 22.3581 19.3776 22.0854 19.1339 21.7498C18.8667 21.3583 18.6792 20.9207 18.5814 20.4608C18.4559 19.8915 18.3953 19.3105 18.4008 18.7283C18.3965 18.1461 18.457 17.5653 18.5814 16.9958C18.6811 16.5364 18.8685 16.0992 19.1339 15.7067C19.3776 15.3711 19.7023 15.0985 20.0795 14.9126C20.5044 14.7184 20.97 14.623 21.4395 14.6342C21.881 14.6016 22.3236 14.6793 22.7254 14.8598C23.1271 15.0403 23.4745 15.3177 23.7345 15.6655C24.2824 16.58 24.5411 17.6308 24.4783 18.687C24.5411 19.7432 24.2824 20.794 23.7345 21.7086C23.4844 22.0715 23.1413 22.3651 22.7389 22.5604C22.3366 22.7556 21.8888 22.8459 21.4395 22.8223ZM21.4395 21.5642C21.6537 21.5766 21.8672 21.53 22.0552 21.4296C22.2432 21.3292 22.3981 21.1792 22.502 20.997C22.756 20.5147 22.8906 19.9815 22.8952 19.4398V18.0167C22.9181 17.4848 22.8126 16.9551 22.587 16.4698C22.4683 16.2932 22.306 16.1481 22.1149 16.0477C21.9238 15.9473 21.71 15.8947 21.4927 15.8947C21.2754 15.8947 21.0615 15.9473 20.8704 16.0477C20.6793 16.1481 20.5171 16.2932 20.3983 16.4698C20.1727 16.9551 20.0672 17.4848 20.0902 18.0167V19.4398C20.0682 19.975 20.1737 20.5078 20.3983 20.997C20.4996 21.1768 20.651 21.3253 20.8351 21.4256C21.0192 21.5259 21.2286 21.5739 21.4395 21.5642ZM11.877 22.6883V21.4714H14.002V16.1192L12.0258 17.1505L11.4414 16.0573L13.9064 14.7167H15.4577V21.4198H17.3489V22.6883H11.877Z" fill="white" fillOpacity="0.5"/>
                                </svg>   
                            </button>
                            <div className="custom-flowbite-dropdown-container">
                                <Dropdown 
                                    label="" 
                                    arrowIcon={false} 
                                    color={'transparent'} 
                                    className="custom-flowbite-dropdown"
                                    renderTrigger={() => <span className="flex lg:hidden">
                                        <div className="cursor-pointer dots-img-elem w-[22px] h-[22px] bg-white"></div>
                                    </span>}
                                >
                                    <div className="py-2 text-sm text-white" aria-labelledby="multiLevelDropdownButton">
                                        <div>
                                            <span
                                                id="doubleDropdownButton1"
                                                data-dropdown-toggle="repeatDropdown"
                                                data-dropdown-placement="top"
                                                type="button"
                                                className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black relative"
                                            >
                                                Repeat settings
                                                <svg
                                                    className="w-2.5 h-2.5 ml-2.5"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 6 10"
                                                >
                                                    <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="m1 9 4-4-4-4"
                                                    />
                                                </svg>
                                                <div className="absolute left-0 flex-none custom-flowbite-repeat-dropdown-container w-full pt-2">
                                                    {
                                                        isRepeatMenuOpen?
                                                            <Dropdown 
                                                                label="" 
                                                                arrowIcon={false} 
                                                                color={'transparent'} 
                                                                className="custom-flowbite-dropdown w-fit"
                                                            >
                                                                <div className="w-[296px]">
                                                                    <form className="w-full flex flex-col">
                                                                        <div id="rangeToggle">
                                                                            <div className="flex p-2 rounded">
                                                                                <label className="relative inline-flex items-center w-full cursor-pointer">
                                                                                    <input
                                                                                    type="checkbox"
                                                                                    checked={isRangeRepeatChecked}
                                                                                    onChange={handleRangeRepeatChange}
                                                                                    className="sr-only peer"
                                                                                    id="rangeRepeatToggle"
                                                                                    />
                                                                                    <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
                                                                                    <span className="ml-3 text-sm font-medium text-white">Range repetition</span>
                                                                                </label>
                                                                            </div>
                                                                        </div>

                                                                        <div id="surahToggle">
                                                                            <div className="flex p-2 rounded">
                                                                                <label className="relative inline-flex items-center w-full cursor-pointer">
                                                                                    <input
                                                                                    type="checkbox"
                                                                                    checked={isSurahRepeatChecked}
                                                                                    onChange={handleSurahRepeatChange}
                                                                                    className="sr-only peer"
                                                                                    id="surahRepeatToggle"
                                                                                    />
                                                                                    <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
                                                                                    <span className="ml-3 text-sm font-medium text-white">Surah repetition</span>
                                                                                </label>
                                                                            </div>
                                                                        </div>

                                                                        {showRangeControls && (
                                                                            <div id="rangeCtrls">
                                                                                <div className="p-3">
                                                                                    <div className="relative">
                                                                                        <span className="text-white">From : </span>
                                                                                        <input
                                                                                            type="number"
                                                                                            min={1}
                                                                                            max={nowPlaying.count}
                                                                                            id="fromRange"
                                                                                            value={fromRange}
                                                                                            onChange={handleFromRangeChange}
                                                                                            className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                                        />
                                                                                        <label className="text-white ml-3">To : </label>
                                                                                        <input
                                                                                            type="number"
                                                                                            min={1}
                                                                                            max={nowPlaying.count}
                                                                                            id="toRange"
                                                                                            value={toRange}
                                                                                            onChange={handleToRangeChange}
                                                                                            className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        
                                                                        <div id="surahCtrls">
                                                                            <div className="p-3">
                                                                                <div className="relative">
                                                                                <span className="text-white">Repeat each ayahs :</span>&nbsp;&nbsp;&nbsp;
                                                                                <input
                                                                                    type="number"
                                                                                    min="2"
                                                                                    max="8"
                                                                                    id="repeatAmtRange"
                                                                                    value={repeatAmtRange}
                                                                                    onChange={handleRepeatAmtRangeChange}
                                                                                    className="ml-2 w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                                />
                                                                                </div>
                                                                            </div>

                                                                            <div className="p-3">
                                                                                <div className="relative">
                                                                                <span className="text-white w-36">Repeat range:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                <input
                                                                                    required
                                                                                    type="number"
                                                                                    min="1"
                                                                                    max="8"
                                                                                    id="repeatAmt"
                                                                                    value={repeatAmt}
                                                                                    onChange={handleRepeatAmtChange}
                                                                                    className="ml-2 inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                                />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div id="submitBtn">
                                                                            <div className="grid grid-cols-2 w-full">
                                                                            <div className="col-span-1">
                                                                                <button
                                                                                    type="button"
                                                                                    className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg hover:bg-white"
                                                                                    onClick={() => {
                                                                                        setIsRepeatMenuOpen(false);
                                                                                        setFromRange(1);
                                                                                        setToRange(nowPlaying.count);
                                                                                        setRepeatAmtRange(1);
                                                                                        setRepeatAmt(1);
                                                                                        setCurrentTrack(0);
                                                                                    }}
                                                                                >
                                                                                    Cancel Repeat
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-span-1">
                                                                                <button
                                                                                type="button"
                                                                                id="loopToggle"
                                                                                className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg hover:bg-white"
                                                                                onClick={handleStartPlaying}
                                                                                >
                                                                                Start Playing
                                                                                </button>
                                                                            </div>
                                                                            </div>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </Dropdown>
                                                        :
                                                            null
                                                    }
                                                </div>
                                            </span>
                                        </div>
                                        <div>
                                            <Dropdown 
                                                label="" 
                                                arrowIcon={false} 
                                                color={'transparent'} 
                                                className="custom-flowbite-dropdown w-64"
                                                renderTrigger={() => 
                                                    <span
                                                        id="doubleDropdownButton"
                                                        data-dropdown-toggle="dropdownReciter"
                                                        data-dropdown-placement="top"
                                                        type="button"
                                                        className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black cursor-pointer"
                                                    >
                                                        Reciter settings
                                                        <svg
                                                            className="w-2.5 h-2.5 ml-2.5"
                                                            aria-hidden="true"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 6 10"
                                                        >
                                                            <path
                                                            stroke="currentColor"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="m1 9 4-4-4-4"
                                                            />
                                                        </svg>
                                                    </span>
                                                }
                                            >
                                                <div className="max-h-80 overflow-auto">
                                                    {
                                                        recitersList.map((reciter) => (
                                                            <div key={reciter.value} className="flex items-center w-full px-2 py-2">
                                                                <input
                                                                    type="radio"
                                                                    id={`speed-${reciter.value}`}
                                                                    value={JSON.stringify(reciter)}
                                                                    name="speed"
                                                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                                                                    checked={_.isEqual(selectedReciter, reciter)}
                                                                    onChange={handleReciterChange}
                                                                />
                                                                <label
                                                                    htmlFor={`speed-${reciter.value}`}
                                                                    className="ml-2 text-sm font-medium grow cursor-pointer text-left"
                                                                >
                                                                    {reciter.label}
                                                                </label>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </Dropdown>
                                        </div>
                                        <div>
                                            <Dropdown 
                                                label="" 
                                                arrowIcon={false} 
                                                color={'transparent'} 
                                                className="custom-flowbite-dropdown w-28"
                                                renderTrigger={() => <span
                                                    id="doubleDropdownButton"
                                                    data-dropdown-toggle="dropdownSpeed"
                                                    data-dropdown-placement="top"
                                                    type="button"
                                                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black cursor-pointer"
                                                    >
                                                        Playback speed settings
                                                        <svg
                                                            className="w-2.5 h-2.5 ml-2.5"
                                                            aria-hidden="true"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 6 10"
                                                        >
                                                            <path
                                                            stroke="currentColor"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="m1 9 4-4-4-4"
                                                            />
                                                        </svg>
                                                    </span>
                                                }
                                            >
                                                {
                                                    speedOptions.map((speed) => (
                                                        <div key={speed.value} className="flex items-center w-full px-2 py-2">
                                                            <input
                                                                type="radio"
                                                                id={`speed-${speed.value}`}
                                                                value={speed.value}
                                                                name="speed"
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                                                                checked={selectedSpeed === speed.value}
                                                                onChange={handleSpeedChange}
                                                            />
                                                            <label
                                                                htmlFor={`speed-${speed.value}`}
                                                                className="ml-2 text-sm font-medium grow cursor-pointer"
                                                            >
                                                                {speed.label}
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                            </Dropdown>
                                        </div>
                                    </div>
                                </Dropdown>
                            </div>
                            <button className="px-2 py-0.5 flex lg:hidden" onClick={()=>{closeFunc(false)}}> 
                                <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.29279 8.30529C7.48031 8.11782 7.73462 8.0125 7.99979 8.0125C8.26495 8.0125 8.51926 8.11782 8.70679 8.30529L12.9998 12.5983L17.2928 8.30529C17.385 8.20978 17.4954 8.1336 17.6174 8.08119C17.7394 8.02878 17.8706 8.00119 18.0034 8.00004C18.1362 7.99888 18.2678 8.02419 18.3907 8.07447C18.5136 8.12475 18.6253 8.199 18.7192 8.29289C18.8131 8.38679 18.8873 8.49844 18.9376 8.62133C18.9879 8.74423 19.0132 8.87591 19.012 9.00869C19.0109 9.14147 18.9833 9.27269 18.9309 9.39469C18.8785 9.5167 18.8023 9.62704 18.7068 9.71929L14.4138 14.0123L18.7068 18.3053C18.8889 18.4939 18.9897 18.7465 18.9875 19.0087C18.9852 19.2709 18.88 19.5217 18.6946 19.7071C18.5092 19.8925 18.2584 19.9977 17.9962 20C17.734 20.0022 17.4814 19.9014 17.2928 19.7193L12.9998 15.4263L8.70679 19.7193C8.51818 19.9014 8.26558 20.0022 8.00339 20C7.74119 19.9977 7.49038 19.8925 7.30497 19.7071C7.11956 19.5217 7.01439 19.2709 7.01211 19.0087C7.00983 18.7465 7.11063 18.4939 7.29279 18.3053L11.5858 14.0123L7.29279 9.71929C7.10532 9.53176 7 9.27745 7 9.01229C7 8.74712 7.10532 8.49282 7.29279 8.30529Z" fill="#9CA3AF"/>
                                    <circle cx="13" cy="14" r="13" fill="white" fillOpacity="0.1"/>
                                </svg> 
                            </button>
                        </div>
                    </div>
                    <div className="lg:col-span-1 pt-2 cursor-pointer hidden lg:flex relative">
                        <Dropdown 
                            label="" 
                            arrowIcon={false} 
                            color={'transparent'} 
                            className="custom-flowbite-dropdown w-28"
                            renderTrigger={() => <div className="speed-label">
                                <p id="media-speed-label" className="text-white/50">{selectedSpeed}x Speed</p>
                            </div>}
                        >
                            {
                                speedOptions.map((speed) => (
                                    <div key={speed.value} className="flex items-center w-full px-2 py-2">
                                        <input
                                            type="radio"
                                            id={`speed-${speed.value}`}
                                            value={speed.value}
                                            name="speed"
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                                            checked={selectedSpeed === speed.value}
                                            onChange={handleSpeedChange}
                                        />
                                        <label
                                            htmlFor={`speed-${speed.value}`}
                                            className="ml-2 text-sm font-medium grow cursor-pointer"
                                        >
                                            {speed.label}
                                        </label>
                                    </div>
                                ))
                            }
                        </Dropdown>
                    </div>

                    <div className="lg:col-span-1 cursor-pointer hidden lg:flex min-w-[78px]">
                        <Dropdown 
                            label="" 
                            arrowIcon={false} 
                            color={'transparent'} 
                            className="custom-flowbite-dropdown w-64"
                            renderTrigger={() => 
                                <span className="flex items-center gap-2">
                                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M10.5 1.22461C9.27602 1.22298 8.09272 1.66374 7.16808 2.46566C6.24344 3.26759 5.63976 4.37666 5.46827 5.58853C5.29677 6.8004 5.56902 8.03342 6.23485 9.06041C6.90068 10.0874 7.91522 10.8392 9.09156 11.1772C7.41996 11.3802 5.98636 11.971 4.90556 13.0364C3.53076 14.3902 2.83496 16.4076 2.83496 19.0396C2.83496 19.216 2.90502 19.3851 3.02973 19.5098C3.15445 19.6346 3.32359 19.7046 3.49996 19.7046C3.67633 19.7046 3.84548 19.6346 3.97019 19.5098C4.0949 19.3851 4.16496 19.216 4.16496 19.0396C4.16496 16.6316 4.79916 15.0076 5.83936 13.9828C6.88096 12.9566 8.43776 12.4246 10.5 12.4246C12.5622 12.4246 14.119 12.9566 15.162 13.9828C16.2008 15.009 16.835 16.6316 16.835 19.0396C16.835 19.216 16.905 19.3851 17.0297 19.5098C17.1544 19.6346 17.3236 19.7046 17.5 19.7046C17.6763 19.7046 17.8455 19.6346 17.9702 19.5098C18.0949 19.3851 18.165 19.216 18.165 19.0396C18.165 16.4076 17.4692 14.3916 16.093 13.0364C15.015 11.9724 13.58 11.3802 11.9084 11.1772C13.0808 10.8354 14.0907 10.0825 14.7531 9.05645C15.4154 8.03045 15.6858 6.8001 15.5147 5.59092C15.3436 4.38174 14.7424 3.27473 13.8214 2.4728C12.9004 1.67086 11.7212 1.22773 10.5 1.22461ZM6.75496 6.29961C6.75496 5.30638 7.14952 4.35382 7.85185 3.6515C8.55417 2.94918 9.50673 2.55461 10.5 2.55461C11.4932 2.55461 12.4458 2.94918 13.1481 3.6515C13.8504 4.35382 14.245 5.30638 14.245 6.29961C14.245 7.29285 13.8504 8.24541 13.1481 8.94773C12.4458 9.65005 11.4932 10.0446 10.5 10.0446C9.50673 10.0446 8.55417 9.65005 7.85185 8.94773C7.14952 8.24541 6.75496 7.29285 6.75496 6.29961Z" fill="white" fillOpacity="0.5"/>
                                    </svg> 
                                    <div className="reciter-label min-h-7">
                                        <p id="media-reciter-label" className="text-white/50">{selectedReciter.label}</p>
                                    </div>
                                </span>
                            }
                        >
                            <div className="max-h-80 overflow-auto">
                                {
                                    recitersList.map((reciter) => (
                                        <div key={reciter.value} className="flex items-center w-full px-2 py-2">
                                            <input
                                                type="radio"
                                                id={`speed-${reciter.value}`}
                                                value={JSON.stringify(reciter)}
                                                name="speed"
                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                                                checked={_.isEqual(selectedReciter, reciter)}
                                                onChange={handleReciterChange}
                                            />
                                            <label
                                                htmlFor={`speed-${reciter.value}`}
                                                className="ml-2 text-sm font-medium grow cursor-pointer"
                                            >
                                                {reciter.label}
                                            </label>
                                        </div>
                                    ))
                                }
                            </div>
                        </Dropdown>
                    </div>

                    <div id="repeatBtn" className="lg:col-span-1 pt-2 cursor-pointer hidden lg:flex min-w-[78px] relative">
                
                        
                        <div className="absolute left-0 flex-none custom-flowbite-repeat-dropdown-container w-full">
                            {
                                isRepeatMenuOpen?
                                    <Dropdown 
                                        label="" 
                                        arrowIcon={false} 
                                        color={'transparent'} 
                                        className="custom-flowbite-dropdown w-fit"
                                        renderTrigger={()=>
                                            <span className="hidden lg:flex">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="text-white text-opacity-50 mt-0.5" width="21" height="21">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"/>
                                                </svg>
                                                <p className="text-white/50 ml-2">Repeat</p>
                                            </span>
                                        }
                                    >
                                        <div className="w-[296px]">
                                            <form className="w-full flex flex-col">
                                                <div id="rangeToggle">
                                                    <div className="flex p-2 rounded">
                                                        <label className="relative inline-flex items-center w-full cursor-pointer">
                                                            <input
                                                            type="checkbox"
                                                            checked={isRangeRepeatChecked}
                                                            onChange={handleRangeRepeatChange}
                                                            className="sr-only peer"
                                                            id="rangeRepeatToggle"
                                                            />
                                                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
                                                            <span className="ml-3 text-sm font-medium text-white">Range repetition</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div id="surahToggle">
                                                    <div className="flex p-2 rounded">
                                                        <label className="relative inline-flex items-center w-full cursor-pointer">
                                                            <input
                                                            type="checkbox"
                                                            checked={isSurahRepeatChecked}
                                                            onChange={handleSurahRepeatChange}
                                                            className="sr-only peer"
                                                            id="surahRepeatToggle"
                                                            />
                                                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
                                                            <span className="ml-3 text-sm font-medium text-white">Surah repetition</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                {showRangeControls && (
                                                    <div id="rangeCtrls">
                                                        <div className="p-3">
                                                            <div className="relative">
                                                                <span className="text-white">From : </span>
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    max={nowPlaying.count}
                                                                    id="fromRange"
                                                                    value={fromRange}
                                                                    onChange={handleFromRangeChange}
                                                                    className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                />
                                                                <label className="text-white ml-3">To : </label>
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    max={nowPlaying.count}
                                                                    id="toRange"
                                                                    value={toRange}
                                                                    onChange={handleToRangeChange}
                                                                    className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                
                                                <div id="surahCtrls">
                                                    <div className="p-3">
                                                        <div className="relative">
                                                        <span className="text-white">Repeat each ayahs :</span>&nbsp;&nbsp;&nbsp;
                                                        <input
                                                            type="number"
                                                            min="2"
                                                            max="8"
                                                            id="repeatAmtRange"
                                                            value={repeatAmtRange}
                                                            onChange={handleRepeatAmtRangeChange}
                                                            className="ml-2 w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        />
                                                        </div>
                                                    </div>

                                                    <div className="p-3">
                                                        <div className="relative">
                                                        <span className="text-white w-36">Repeat range:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <input
                                                            required
                                                            type="number"
                                                            min="1"
                                                            max="8"
                                                            id="repeatAmt"
                                                            value={repeatAmt}
                                                            onChange={handleRepeatAmtChange}
                                                            className="ml-2 inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div id="submitBtn">
                                                    <div className="grid grid-cols-2 w-full">
                                                    <div className="col-span-1">
                                                        <button
                                                            type="button"
                                                            className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg hover:bg-white"
                                                            onClick={() => {
                                                                setIsRepeatMenuOpen(false);
                                                                setFromRange(1);
                                                                setToRange(nowPlaying.count);
                                                                setRepeatAmtRange(1);
                                                                setRepeatAmt(1);
                                                                setCurrentTrack(0);
                                                            }}
                                                        >
                                                            Cancel Repeat
                                                        </button>
                                                    </div>
                                                    <div className="col-span-1">
                                                        <button
                                                        type="button"
                                                        id="loopToggle"
                                                        className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg hover:bg-white"
                                                        onClick={handleStartPlaying}
                                                        >
                                                        Start Playing
                                                        </button>
                                                    </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </Dropdown>
                                :
                                    null
                            }
                        </div>
                    </div>
                    </div>

                    <div className="lg:col-span-1 time hidden lg:block">
                        <div className="bg-white/10 w-20 text-center rounded p-2 float-right"><span className="text-white/50 length">{getTimeCodeFromNum(duration)}</span></div>
                    </div>
                </div> */}
            
            
            
                {/* <!-- desktop media player --> */}
                <div className="w-full max-w-screen-xl mx-auto px-4">
                    {/* <!-- Media player timer and seeker --> */}
                    <div className="flex gap-4 items-center controls">
                    <div className="time hidden lg:block">
                        <div className="text-center rounded"><span className="text-light-blue dark:text-white current">{getTimeCodeFromNum(currentTime)}</span></div>
                    </div>
                    <div 
                        ref={timelineRef}
                        onClick={handleTimelineClick}
                        className="w-full h-0.5 bg-light-blue/50 dark:bg-white cursor-pointer timeline grow">
                        <div ref={progressRef} className="progress bg-deep-red"></div>
                    </div>
                    <div className="time hidden lg:block">
                        <div className="text-center rounded float-right"><span className="text-light-blue dark:text-white length">{getTimeCodeFromNum(duration)}</span></div>
                    </div>
                    </div>

                    {/* <!-- Media player controls --> */}
                    <div className="hidden lg:flex gap-2 items-center controls pb-3">
                    <div className="flex gap-5">
                        <div className="text-white/50 cursor-pointer toggle-play flex items-center">
                            {
                                isLoading?
                                    <LoaderCircle/>
                                :
                                    isPlaying?
                                        <span className="media-player-pause-icon media-player-icon-common min-w-[15px] w-5 h-5 block" onClick={pauseAudio} title="Pause"></span>
                                    :
                                        <span className="media-player-play-icon media-player-icon-common min-w-[15px] w-5 h-5 block" onClick={playAudio} title="Play"></span>
                            }
                        </div>
                        <div onClick={skipBackward} className="text-white/50 cursor-pointer" title="Skip 2 seconds backward">
                            <span className="media-player-skip-prev-icon media-player-icon-common min-w-[15px] w-6 h-7 block"></span>
                        </div>
                        <div onClick={skipForward} className="text-white/50 cursor-pointer" title="Skip 2 seconds forward">
                            <span className="media-player-skip-next-icon media-player-icon-common min-w-[15px] w-6 h-7 block"></span>
                        </div>
                        <div className="volume-container">
                            <div className="volume-button flex items-center h-full cursor-pointer"> 
                                {
                                    isMuted?
                                        // <img src="/images/media-player/mute.svg" width="20" height="17" alt="Pause button" onClick={unMuteVolume}/>
                                        <span className="media-player-muted-icon media-player-icon-common min-w-[15px] w-5 h-5 block" onClick={unMuteVolume} title="Unmute"></span>
                                    :
                                        <span className="media-player-volume-icon media-player-icon-common min-w-[15px] w-5 h-5 block" onClick={muteVolume} title="Mute"></span>
                                }
                            </div>
                            <div 
                                ref={volSliderRef}
                                onClick={handleVolume}
                                className="volume-slider">
                                <div 
                                    className="volume-percentage"
                                    style={{
                                        width: `${volume * 100}%`,
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div id="media-info" className="text-light-blue dark:text-white p-2 grow text-center">
                        {
                            playList!==null?
                                `${nowPlaying.name} (${nowPlaying.id}:${playList[currentTrack].ayahId})`
                            :
                                null
                        }
                    </div>
                    <div className="flex gap-2">
                        <div onClick={()=>{closeFunc(false)}} className="p-2 bg-light-blue rounded-md min-w-10 min-h-10 text-light-beige cursor-pointer" title="Close media player">
                            <img src="/images/media-player/close-btn.svg" width="25" height="30" alt="Pause button" className="min-w-[15px] h-full"/>
                        </div>
                        <div onClick={gotoPrev} className="p-2 bg-light-blue rounded-md min-w-10 min-h-10 cursor-pointer" title="Skip to previous ayah">
                            <img src="/images/media-player/previous.svg" width="25" height="30" alt="Pause button" className="min-w-[15px] h-full"/>
                        </div>
                        <div onClick={gotoNext} className="p-2 bg-light-blue rounded-md min-w-10 min-h-10 cursor-pointer" title="Skip to next ayah">
                            <img src="/images/media-player/next.svg" width="25" height="30" alt="Pause button" className="min-w-[15px] h-full"/>
                        </div>
                        <Dropdown 
                            label="" 
                            arrowIcon={false} 
                            color={'transparent'} 
                            className="custom-flowbite-dropdown w-full max-w-[400px]"
                            renderTrigger={() => 
                                <div className="cursor-pointer p-2 bg-light-blue rounded-md min-w-10 min-h-10" title="Playback speed">
                                    <img src="/images/media-player/speed.svg" width="25" height="30" alt="Pause button" className="min-w-[15px] h-full"/>
                                </div>
                            }
                        >
                            {/* {
                                speedOptions.map((speed) => (
                                    <div key={speed.value} className="flex items-center w-full px-2 py-2">
                                        <input
                                            type="radio"
                                            id={`speed-${speed.value}`}
                                            value={speed.value}
                                            name="speed"
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                                            checked={selectedSpeed === speed.value}
                                            onChange={handleSpeedChange}
                                        />
                                        <label
                                            htmlFor={`speed-${speed.value}`}
                                            className="ml-2 text-sm font-medium grow cursor-pointer"
                                        >
                                            {speed.label}
                                        </label>
                                    </div>
                                ))
                            } */}

                            <SpeedControls speedOptions={speedOptions} selectedSpeed={selectedSpeed} speedValFunc={setSelectedSpeed} mediaPlayerRef={audioRef}/>
                        </Dropdown>
                        <Dropdown 
                            label="" 
                            arrowIcon={false} 
                            color={'transparent'} 
                            className="custom-flowbite-dropdown"
                            renderTrigger={() => 
                                <div className="cursor-pointer p-2 bg-light-blue rounded-md min-w-10 min-h-10" title="Reciters">
                                    <img src="/images/media-player/reciters.svg" width="25" height="30" alt="Pause button" className="min-w-[15px] h-full"/>
                                </div>
                            }
                        >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 reciter-dropdown-react py-3 px-1 md:px-3">

                                {
                                    recitersList.map((reciter) => (
                                        <div key={reciter.value} className="flex items-center w-full">
                                            <input
                                                type="radio"
                                                id={`speed-${reciter.value}`}
                                                value={JSON.stringify(reciter)}
                                                name="default-radio"
                                                className="hidden reciter-radio"
                                                checked={_.isEqual(selectedReciter, reciter)}
                                                onChange={handleReciterChange}
                                            />
                                            <label
                                                htmlFor={`speed-${reciter.value}`}
                                                className="text-sm font-medium grow cursor-pointer"
                                            >
                                                {reciter.label}
                                            </label>
                                        </div>
                                    ))
                                }
                            </div>
                        </Dropdown>
                        <div className="custom-flowbite-repeat-dropdown-container">
                            {
                                isRepeatMenuOpen?
                                    <Dropdown 
                                        label="" 
                                        arrowIcon={false} 
                                        color={'transparent'} 
                                        className="custom-flowbite-dropdown w-fit"
                                        renderTrigger={()=>
                                            <div className="cursor-pointer p-2 bg-light-blue rounded-md min-w-10 min-h-10" title="Repeat">
                                                <img src="/images/media-player/repeat.svg" width="25" height="30" alt="Pause button" className="min-w-[15px] h-full"/>
                                            </div>
                                        }
                                    >
                                        <div className="w-[296px]">
                                            <form className="w-full flex flex-col">
                                                <div id="rangeToggle">
                                                    <div className="flex p-4 rounded">
                                                        <label className="relative inline-flex items-center w-full cursor-pointer">
                                                            <input
                                                            type="checkbox"
                                                            checked={isRangeRepeatChecked}
                                                            onChange={handleRangeRepeatChange}
                                                            className="sr-only peer"
                                                            id="rangeRepeatToggle"
                                                            />
                                                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-deep-red"></div>
                                                            <span className="ml-3 text-sm font-medium text-white">Range repetition</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div id="surahToggle">
                                                    <div className="flex p-4 rounded">
                                                        <label className="relative inline-flex items-center w-full cursor-pointer">
                                                            <input
                                                            type="checkbox"
                                                            checked={isSurahRepeatChecked}
                                                            onChange={handleSurahRepeatChange}
                                                            className="sr-only peer"
                                                            id="surahRepeatToggle"
                                                            />
                                                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-deep-red"></div>
                                                            <span className="ml-3 text-sm font-medium text-white">Surah repetition</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                {showRangeControls && (
                                                    <div id="rangeCtrls">
                                                        <div className="p-3 relative flex justify-between">
                                                            <div>
                                                                <span className="text-white">From : </span>
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    max={nowPlaying.count}
                                                                    id="fromRange"
                                                                    value={fromRange}
                                                                    onChange={handleFromRangeChange}
                                                                    className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="text-white ml-3">To : </label>
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    max={nowPlaying.count}
                                                                    id="toRange"
                                                                    value={toRange}
                                                                    onChange={handleToRangeChange}
                                                                    className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                
                                                <div id="surahCtrls">
                                                    <div className="p-3">
                                                        <div className="relative flex justify-between">
                                                        <span className="text-white">Repeat each ayahs :</span>&nbsp;&nbsp;&nbsp;
                                                            <input
                                                                type="number"
                                                                min="2"
                                                                max="8"
                                                                id="repeatAmtRange"
                                                                value={repeatAmtRange}
                                                                onChange={handleRepeatAmtRangeChange}
                                                                className="ml-2 w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="p-3">
                                                        <div className="relative flex justify-between">
                                                        <span className="text-white">Repeat range:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <input
                                                            required
                                                            type="number"
                                                            min="1"
                                                            max="8"
                                                            id="repeatAmt"
                                                            value={repeatAmt}
                                                            onChange={handleRepeatAmtChange}
                                                            className="ml-2 inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div id="submitBtn">
                                                    <div className="grid grid-cols-2 w-full">
                                                    <div className="col-span-1">
                                                        <button
                                                            type="button"
                                                            className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg hover:bg-white"
                                                            onClick={() => {
                                                                setIsRepeatMenuOpen(false);
                                                                setFromRange(1);
                                                                setToRange(nowPlaying.count);
                                                                setRepeatAmtRange(1);
                                                                setRepeatAmt(1);
                                                                setCurrentTrack(0);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                    <div className="col-span-1">
                                                        <button
                                                        type="button"
                                                        id="loopToggle"
                                                        className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg hover:bg-white"
                                                        onClick={handleStartPlaying}
                                                        >
                                                        Start Playing
                                                        </button>
                                                    </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </Dropdown>
                                :
                                    null
                            }
                        </div>
                    </div>
                    </div>
                </div>

                {/* <!-- mobile media player --> */}
                <div className="w-full flex lg:hidden justify-between pt-2 px-4">
                    <div className="flex items-center">
                        <div className="text-light-blue dark:text-white text-center">
                            {
                                playList!==null?
                                    `${nowPlaying.name} (${nowPlaying.id}:${playList[currentTrack].ayahId})`
                                :
                                    null
                            }
                        </div>
                    </div>
                    <div>
                    {/* <!-- media controls --> */}
                    <div className="text-white/50 cursor-pointer controls flex items-center gap-4">
                        <div onClick={gotoPrev} className="min-w-10 min-h-10 flex items-center justify-center" title="Skip to previous ayah">
                            <span className="media-player-prev-icon media-player-icon-common min-w-[15px] w-6 h-6 block"></span>
                        </div>
                        <div className="toggle-play">
                        {
                                isLoading?
                                    <LoaderCircle/>
                                :
                                    isPlaying?
                                        <span className="media-player-pause-icon-mobile media-player-icon-common min-w-[15px] w-5 h-6 block" onClick={pauseAudio} title="Pause"></span>
                                    :
                                        <span className="media-player-play-icon-mobile media-player-icon-common min-w-[15px] w-5 h-6 block" onClick={playAudio} title="Play"></span>
                            }
                        </div>
                        <div onClick={gotoNext} className="min-w-10 min-h-10  flex items-center justify-center" title="Skip to next ayah">
                            <span className="media-player-next-icon media-player-icon-common min-w-[15px] w-6 h-6 block"></span>
                        </div>
                    </div>
                    </div>
                    <div className="custom-flowbite-dropdown-container flex items-center">
                        <Dropdown 
                            label="" 
                            arrowIcon={false} 
                            color={'transparent'} 
                            className="custom-flowbite-dropdown w-[calc(100%-17px)] md:w-fit"
                            renderTrigger={() => <span className="media-player-three-dot-icon media-player-icon-common min-w-[15px] w-6 h-3 block cursor-pointer" title="More options"></span>}
                        >
                            <div className="py-2 text-sm text-white" aria-labelledby="multiLevelDropdownButton">
                                <div>
                                    <span
                                        id="doubleDropdownButton1"
                                        data-dropdown-toggle="repeatDropdown"
                                        data-dropdown-placement="top"
                                        type="button"
                                        className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black relative"
                                    >
                                        Repeat settings
                                        <svg
                                            className="w-2.5 h-2.5 ml-2.5"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 6 10"
                                        >
                                            <path
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="m1 9 4-4-4-4"
                                            />
                                        </svg>
                                        <div className="absolute left-0 flex-none custom-flowbite-repeat-dropdown-container w-full pt-2">
                                            {
                                                isRepeatMenuOpen?
                                                    <Dropdown 
                                                        label="" 
                                                        arrowIcon={false} 
                                                        color={'transparent'} 
                                                        className="custom-flowbite-dropdown w-[296px] !min-w-[296px]"
                                                    >
                                                        <div className="w-[296px]">
                                                            <form className="w-full flex flex-col">
                                                                <div id="rangeToggle">
                                                                    <div className="flex p-4 rounded">
                                                                        <label className="relative inline-flex items-center w-full cursor-pointer">
                                                                            <input
                                                                            type="checkbox"
                                                                            checked={isRangeRepeatChecked}
                                                                            onChange={handleRangeRepeatChange}
                                                                            className="sr-only peer"
                                                                            id="rangeRepeatToggle"
                                                                            />
                                                                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-deep-red"></div>
                                                                            <span className="ml-3 text-sm font-medium text-white">Range repetition</span>
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div id="surahToggle">
                                                                    <div className="flex p-4 rounded">
                                                                        <label className="relative inline-flex items-center w-full cursor-pointer">
                                                                            <input
                                                                            type="checkbox"
                                                                            checked={isSurahRepeatChecked}
                                                                            onChange={handleSurahRepeatChange}
                                                                            className="sr-only peer"
                                                                            id="surahRepeatToggle"
                                                                            />
                                                                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-deep-red"></div>
                                                                            <span className="ml-3 text-sm font-medium text-white">Surah repetition</span>
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                {showRangeControls && (
                                                                    <div id="rangeCtrls">
                                                                        <div className="p-3 relative flex justify-between w-full">
                                                                            <div>
                                                                                <span className="text-white">From : </span>
                                                                                <input
                                                                                    type="number"
                                                                                    min={1}
                                                                                    max={nowPlaying.count}
                                                                                    id="fromRange"
                                                                                    value={fromRange}
                                                                                    onChange={handleFromRangeChange}
                                                                                    className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <label className="text-white">To : </label>
                                                                                <input
                                                                                    type="number"
                                                                                    min={1}
                                                                                    max={nowPlaying.count}
                                                                                    id="toRange"
                                                                                    value={toRange}
                                                                                    onChange={handleToRangeChange}
                                                                                    className="inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                
                                                                <div id="surahCtrls">
                                                                    <div className="p-3 relative flex justify-between">
                                                                        <span className="text-white">Repeat each ayahs :</span>
                                                                        <input
                                                                            type="number"
                                                                            min="2"
                                                                            max="8"
                                                                            id="repeatAmtRange"
                                                                            value={repeatAmtRange}
                                                                            onChange={handleRepeatAmtRangeChange}
                                                                            className="ml-2 w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                        />
                                                                    </div>

                                                                    <div className="p-3 relative flex justify-between">
                                                                        <span className="text-white w-36">Repeat range:</span>
                                                                        <input
                                                                            required
                                                                            type="number"
                                                                            min="1"
                                                                            max="8"
                                                                            id="repeatAmt"
                                                                            value={repeatAmt}
                                                                            onChange={handleRepeatAmtChange}
                                                                            className="ml-2 inline w-20 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div id="submitBtn">
                                                                    <div className="grid grid-cols-2 w-full">
                                                                    <div className="col-span-1">
                                                                        <button
                                                                            type="button"
                                                                            className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-light-blue rounded-b-lg hover:bg-white"
                                                                            onClick={() => {
                                                                                setIsRepeatMenuOpen(false);
                                                                                setFromRange(1);
                                                                                setToRange(nowPlaying.count);
                                                                                setRepeatAmtRange(1);
                                                                                setRepeatAmt(1);
                                                                                setCurrentTrack(0);
                                                                            }}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-span-1">
                                                                        <button
                                                                        type="button"
                                                                        id="loopToggle"
                                                                        className="w-full items-center p-3 text-sm font-medium text-red-600 border-t border-light-blue rounded-b-lg hover:bg-white"
                                                                        onClick={handleStartPlaying}
                                                                        >
                                                                        Start Playing
                                                                        </button>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </Dropdown>
                                                :
                                                    null
                                            }
                                        </div>
                                    </span>
                                </div>
                                <div>
                                    <Dropdown 
                                        label="" 
                                        arrowIcon={false} 
                                        color={'transparent'} 
                                        className="custom-flowbite-dropdown w-[calc(100%-17px)] md:w-fit md:!min-w-[558px]"
                                        renderTrigger={() => 
                                            <span
                                                id="doubleDropdownButton"
                                                data-dropdown-toggle="dropdownReciter"
                                                data-dropdown-placement="top"
                                                type="button"
                                                className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black cursor-pointer"
                                            >
                                                Reciter settings
                                                <svg
                                                    className="w-2.5 h-2.5 ml-2.5"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 6 10"
                                                >
                                                    <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="m1 9 4-4-4-4"
                                                    />
                                                </svg>
                                            </span>
                                        }
                                    >
                                        <div className="max-h-80 grid grid-cols-1 md:grid-cols-2 gap-3 reciter-dropdown-react py-3 px-1 md:px-3 overflow-auto">
                                            {
                                                recitersList.map((reciter) => (
                                                    <div key={reciter.value} className="flex items-center">
                                                        <input
                                                            type="radio"
                                                            id={`speed-${reciter.value}`}
                                                            value={JSON.stringify(reciter)}
                                                            name="default-radio"
                                                            className="hidden reciter-radio"
                                                            checked={_.isEqual(selectedReciter, reciter)}
                                                            onChange={handleReciterChange}
                                                        />
                                                        <label
                                                            htmlFor={`speed-${reciter.value}`}
                                                            className="ml-2 text-sm font-medium grow cursor-pointer text-left"
                                                        >
                                                            {reciter.label}
                                                        </label>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </Dropdown>
                                </div>
                                <div>
                                    <Dropdown 
                                        label="" 
                                        arrowIcon={false} 
                                        color={'transparent'} 
                                        className="custom-flowbite-dropdown w-full md:w-[400px] max-w-[400px]"
                                        renderTrigger={() => <span
                                            id="doubleDropdownButton"
                                            data-dropdown-toggle="dropdownSpeed"
                                            data-dropdown-placement="top"
                                            type="button"
                                            className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black cursor-pointer"
                                            >
                                                Playback speed settings
                                                <svg
                                                    className="w-2.5 h-2.5 ml-2.5"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 6 10"
                                                >
                                                    <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="m1 9 4-4-4-4"
                                                    />
                                                </svg>
                                            </span>
                                        }
                                    >
                                        {/* {
                                            speedOptions.map((speed) => (
                                                <div key={speed.value} className="flex items-center w-full px-2 py-2">
                                                    <input
                                                        type="radio"
                                                        id={`speed-${speed.value}`}
                                                        value={speed.value}
                                                        name="speed"
                                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                                                        checked={selectedSpeed === speed.value}
                                                        onChange={handleSpeedChange}
                                                    />
                                                    <label
                                                        htmlFor={`speed-${speed.value}`}
                                                        className="ml-2 text-sm font-medium grow cursor-pointer"
                                                    >
                                                        {speed.label}
                                                    </label>
                                                </div>
                                            ))
                                        } */}
                                        <SpeedControls speedOptions={speedOptions} selectedSpeed={selectedSpeed} speedValFunc={setSelectedSpeed} mediaPlayerRef={audioRef}/>
                                    </Dropdown>
                                </div>
                                <div>
                                    <span
                                        className="flex items-center justify-between w-full px-4 py-2 hover:bg-white hover:text-black cursor-pointer"
                                        onClick={()=>{closeFunc(false)}}
                                    >
                                        Close media player
                                    </span>
                                </div>
                            </div>
                        </Dropdown>
                    </div>
                </div>
            </>
            
            <audio 
                ref={audioRef} 
                src={null} 
                onLoadedMetadata={handleLoadedMetadata} 
                onTimeUpdate={() => setCurrentTime(audioRef.current.currentTime)} 
                onEnded={handleEnded}
                onWaiting={handleWaiting}               // When audio is buffering
                onPlaying={handlePlaying}
            />
        </div>
    );
}

export default MediaPlayer;